import React from 'react';
import { Breakpoints, styled, Text, TextAlignment, Layout, Tabs, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { MultipleCTASelection } from 'src/components';
import { OneElementTemplateFullScreen } from 'src/feature-app/Screen';
import { Info } from '@volkswagen-onehub/icons-core';
import { CalendarioCEM } from 'src/forms/Cem/CEMSegundaEntrega/Calendario';

interface CitaCEMSegundaEntregaProps {
	fechaName: string;
	horaName: string;
}

export const CitaCEMSegundaEntrega = (props: CitaCEMSegundaEntregaProps) => {
	const {
		fechaName,
		horaName
	} = props;

	const CalendarioContainer = styled.div`
		margin-top: 50px;
	`;
	const FranjaContainer = styled.div`
		margin-top: 100px;
	`;
	const HorasContainer = styled.div`
		margin: 30px 0;
	`;

	const CTAsHorasManana = [
		{ label: '10:00', value: '10:00' },
		{ label: '10:30', value: '10:30' },
		{ label: '11:00', value: '11:00' },
		{ label: '11:30', value: '11:30' },
		{ label: '12:00', value: '12:00' },
		{ label: '12:30', value: '12:30' },
		{ label: '13:00', value: '13:00' },
	];

	const CTAsHorasTarde = [
		{ label: '16:00', value: '16:00' },
		{ label: '16:30', value: '16:30' },
		{ label: '17:00', value: '17:00' },
		{ label: '17:30', value: '17:30' },
		{ label: '18:00', value: '18:00' },
		{ label: '18:30', value: '18:30' },
		{ label: '19:00', value: '19:00' },
	];

	const handleChangeFranja = (i) => {
		const input1 = document.querySelectorAll(`input[name=${horaName}`)[i ? 0 : 1] as HTMLInputElement;
		input1.disabled = true;

		const input2 = document.querySelectorAll(`input[name=${horaName}`)[i] as HTMLInputElement;
		input2.disabled = false;
	};

	return (
		<Layout appearance={{
			[Breakpoints.default]: [
				{ name: '.', columns: 2 },
				{ name: 'a', columns: 20 },
				{ name: '.', columns: 2 },
				{ name: '.', columns: 4 },
				{ name: 'b', columns: 16 },
				{ name: '.', columns: 4 }
			],
			[Breakpoints.b960]: [
				{ name: '.', columns: 2 },
				{ name: 'a', columns: 12 },
				{ name: '.', columns: 2 },
				{ name: 'b', columns: 6 },
				{ name: '.', columns: 2 }
			]
		}}>
			<CalendarioContainer>
				<CalendarioCEM name={fechaName} />
			</CalendarioContainer>
			<FranjaContainer>
				<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
					Selecciona la franja horaria
				</Text>
				<HorasContainer>
					<Tabs variant="underlined" tabBarVerticalPosition="bottom" onChange={index => {
						handleChangeFranja(index)
					}}>
						{{
							title: <Text>Mañana</Text>,
							content: <OneElementTemplateFullScreen noPadding element={<MultipleCTASelection ctaValues={CTAsHorasManana} name={horaName} />} />,
							key: 'MANANA'
						}}
						{{
							title: <Text>Tarde</Text>,
							content: <OneElementTemplateFullScreen noPadding element={<MultipleCTASelection ctaValues={CTAsHorasTarde} name={horaName} />} />,
							key: 'TARDE'
						}}
					</Tabs>
				</HorasContainer>
				<Text appearance={TokenTextAppearance.copy200}>
					<Info variant="small" /> La duración de la cita será de una hora aproximadamente.
				</Text>
			</FranjaContainer>
		</Layout>
	);
};